import { ChangeEventHandler } from "react";

import SANGJO_PRODUCTS from "@/constants/grouped_sangjo_products.json";
import RefundCalculatorSelect from "./RefundCalculatorSelect";

interface RefundCalculatorSangjoSelectProps {
  id: string;
  label: string;
  sangjoId: keyof typeof SANGJO_PRODUCTS | "";
  onChange: ChangeEventHandler<HTMLInputElement | HTMLTextAreaElement>;
}

export const RefundCalculatorSangjoSelect = ({
  sangjoId,
  onChange,
  id,
  label,
}: RefundCalculatorSangjoSelectProps) => {
  const isValidAllSangjos = Object.values(SANGJO_PRODUCTS).filter(
    (valueList) => valueList.length > 0,
  );

  const sangjoSelectItems = isValidAllSangjos.map((validSangjos) => {
    return {
      text: validSangjos[0].companyName,
      value: validSangjos[0].companyId,
    };
  });

  return (
    <RefundCalculatorSelect
      id={id}
      label={label}
      value={sangjoId}
      items={sangjoSelectItems}
      onChange={onChange}
    />
  );
};
